// extracted by mini-css-extract-plugin
export default {"achievement":"Achievement_achievement__sRfVy","complete":"Achievement_complete__BuIW9"};